import { useMemo as o } from "react";

import { getFilteredRowModel as e, getSortedRowModel as t, useReactTable as a, getCoreRowModel as n, getPaginationRowModel as i } from "@tanstack/react-table";

import { DEFAULT_PAGE_OPTIONS as r } from "../../constants/index.js";

import s from "../../utils/csv/index.js";

const l = ({paginationType: l, data: g, columns: m, isLoading: d, rowId: p, csvFilename: c, pageSizeOptions: u = r, ...w}) => {
    const f = o((() => m), [ m ]), M = {
        ..."server" === l ? {
            manualPagination: !0,
            manualSorting: !0,
            manualFiltering: !0
        } : {
            getSortedRowModel: t(),
            getFilteredRowModel: e()
        }
    }, R = a({
        columns: f,
        data: g,
        ...w,
        getPaginationRowModel: i(),
        getCoreRowModel: n(),
        ...M
    }), v = d || !1;
    return {
        ...R,
        rowId: p,
        isLoading: v,
        paginationType: l,
        exportToCsv: () => {
            s({
                columns: R.getAllColumns(),
                rows: R.getPrePaginationRowModel().rows,
                filename: c
            });
        },
        pageSizeOptions: u
    };
};

export { l as default };
//# sourceMappingURL=index.js.map
